import { render } from "./Upload.vue?vue&type=template&id=1f494ffe&scoped=true&ts=true"
import script from "./Upload.vue?vue&type=script&lang=ts"
export * from "./Upload.vue?vue&type=script&lang=ts"

import "./Upload.vue?vue&type=style&index=0&id=1f494ffe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f494ffe"]])

export default __exports__